export const sizes = {
    PET_SIZE_BELOW_TO_KNEE: 'Below the knee',
    PET_SIZE_KNEE_DEEP: 'Knee-deep',
    PET_SIZE_ABOVE_THE_KNEE: 'Above the knee',
}

export const weight = {
    up_to_3: 'Up to 3 kg',
    up_to_6: 'Up to 6 kg',
    up_to_10: 'Up to 10 kg',
    up_to_15: 'Up to 15 kg',
    up_to_25: 'Up to 25 kg',
    up_to_35: 'Up to 35 kg',
    '35_plus': 'From 35 kg'
}
